import { useCallback } from 'react';

import { Station } from 'dataSources/Typicode/stations';

import {
  useRouteStationServicesFilterContext
} from '../context';

import {
  useFilterTop5Stations,
  useFilterTopPriceEvery100kmActiveFilter
} from '../hooks';

import { useSortStations } from './useSortStations';

export const useGetFilteredStations = () => {
  const {
    isActiveAllFilter,
    isActiveTop5Filter,
    isActiveEvery100kmFilter,
    isActiveStationsServicesHightSorting,
    isActiveStationsServicesLowSorting
  } = useRouteStationServicesFilterContext();
  const sortStations = useSortStations();
  const filterTop5Stations = useFilterTop5Stations();
  const filterTopPriceEvery100kmActiveFilter = useFilterTopPriceEvery100kmActiveFilter();

  const getFilteredStations = useCallback((
    stations: Station[],
    services: number[],
    priceType: string
  ) => {
    if (isActiveAllFilter) {
      if (isActiveStationsServicesHightSorting) {
        return sortStations(stations, services, priceType);
      }

      if (isActiveStationsServicesLowSorting) {
        return sortStations(stations, services, priceType, 'DESC');
      }

      return stations;
    }

    if (isActiveTop5Filter) {
      const filteredStations = filterTop5Stations(stations, services, priceType);

      return isActiveStationsServicesLowSorting ? filteredStations.reverse() : filteredStations;
    }

    if (isActiveEvery100kmFilter) {
      const filteredStations = filterTopPriceEvery100kmActiveFilter(stations, services, priceType);

      if (isActiveStationsServicesHightSorting) {
        // @ts-ignore
        return sortStations(filteredStations, services, priceType);
      }

      if (isActiveStationsServicesLowSorting) {
        // @ts-ignore
        return sortStations(filteredStations, services, priceType, 'DESC');
      }

      return filteredStations;
    }

    return [];
  }, [
    filterTop5Stations,
    filterTopPriceEvery100kmActiveFilter,
    isActiveStationsServicesLowSorting,
    isActiveStationsServicesHightSorting,
    sortStations,
    isActiveAllFilter,
    isActiveTop5Filter,
    isActiveEvery100kmFilter
  ]);

  return getFilteredStations;
};
